<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="data"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :height="250"
      size="small"
      resizable
      border
      :edit-config="{ trigger: 'click', mode: 'cell', enabled: !disabled }"
      :edit-rules="editRules"
      @edit-closed="editClosed"
      :header-cell-style="headerCellStyle"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span style="font-size: 14px; color: #606266">
              {{ $l('tab_title_moq_material_goods_detail') || '关联产品明细' }}
            </span>
            <el-divider direction="vertical" v-if="!disabled"></el-divider>
          </div>
        </slot>
      </template>
      <template v-slot:moq="{ row }">
        <span>
          {{
            (row.moq ? row.moq : '0') +
              ' ' +
              (row.v_moqUnit ? row.v_moqUnit : '')
          }}
        </span>
      </template>
      <template v-slot:fabricWidth="{ row }">
        <span>
          {{
            (row.fabricWidth ? row.fabricWidth : '0') +
              ' ' +
              (row.v_widUnit ? row.v_widUnit : '')
          }}
        </span>
      </template>
      <template v-slot:fabricWeight="{ row }">
        <span>
          {{
            (row.fabricWeight ? row.fabricWeight : '0') +
              ' ' +
              (row.v_fabricWeightUnit ? row.v_fabricWeightUnit : '')
          }}
        </span>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
export default {
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    amzSkuCode: { type: String, default: '' },
    amzMoqCode: { type: String, default: '' },
  },
  data() {
    return {
      data: [],
      loading: false,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.getData(),
        },
      },

      tableColumns: tableColumns(this),

      editRules: {
        usageQty: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入数量',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    headerCellStyle() {
      return {
        backgroundColor: '#bd94c1',
        color: '#ffffff',
      }
    },
    getData() {
      if (!this.amzSkuCode || !this.amzMoqCode) return
      this.loading = true
      this.$api
        .ecomAmzSkuMoqMaterialListApi({
          amzSkuCode: this.amzSkuCode,
          amzMoqCode: this.amzMoqCode,
        })
        .then((res) => {
          this.loading = false
          this.data = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    editClosed({ row }) {
      if (this.disabled) return
      this.$api
        .ecomAmzSkuMoqMaterialUpdateApi({
          ...row,
          moqMaterialDisabled: true,
        })
        .then((res) => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          // this.getData()
        })
    },
  },
}
</script>
